import styled from '@emotion/styled'

import { breakpoints, palette as globalPalette, spacing, Text, typography } from 'main/ui'
import { FilterControl, FilterState, IFiltersPalette } from 'main/util/asset'

const ButtonText = styled(Text)`
  @media (min-width: ${breakpoints.lg}px) {
    font-size: ${typography.fontSize.hint};
    font-weight: ${typography.fontWeight.bold};
  }
`

export const FilterButton = styled(ButtonText.withComponent('button'))<{
  isActive: boolean
  palette?: IFiltersPalette
}>`
  ${({ palette, isActive }) => {
    if (palette) {
      return `
        background: ${controlPart(FilterControl.BUTTON, isActive, palette)};
        color: ${controlPart(FilterControl.TEXT, isActive, palette)};
      `
    }
  }}

  border: none;
  border-radius: 3px;
  cursor: pointer;
  height: 35px;
  line-height: 11px;
  margin: 0 ${spacing.majorScale(1)}px 0 0;
  outline: none;
  padding: 0 ${spacing.minorScale(3)}px;

  ${({ isActive }) => {
    return `
      @media (max-width: ${breakpoints.lg}px) {
        background: ${isActive ? globalPalette.skyBlue2 : globalPalette.white};
        color: ${isActive ? globalPalette.white : globalPalette.mediumGray};
        border: ${isActive ? 'none' : `1px solid ${globalPalette.chrome}`};
      }
    `
  }}
`

export const FormContainer = styled.div<{ isHidden: boolean; leftPos: number }>`
  ${({ isHidden }) => (isHidden ? 'display: none;' : '')}

  left: ${({ leftPos }) => leftPos}px;
  position: absolute;
  top: 40px;
`

function controlPart(part: FilterControl, isActive: boolean, palette: IFiltersPalette) {
  const partAttributes = palette.control[part]

  return partAttributes[isActive ? FilterState.ACTIVE : FilterState.INACTIVE]
}
